module.exports = __webpack_public_path__ + "img/max_packages_boolean.f3755127.svg";